import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import axiosInstance from '../api/axios';
import ReactMarkdown from 'react-markdown';

const Impressum = () => {
  const [content, setContent] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchContent();
  }, []);

  const fetchContent = async () => {
    try {
      const response = await axiosInstance.get('/legal/impressum');
      setContent(response.data.content || getDefaultContent());
    } catch (error) {
      console.error('Error fetching impressum:', error);
      setContent(getDefaultContent());
    } finally {
      setLoading(false);
    }
  };

  const getDefaultContent = () => {
    return `# Impressum

## Angaben gemäß § 5 TMG

**Webseite:** www.homeyoursoul.de

**Betreiber:**
parfumyoursoul
Yasemin Kurt-Yilmaz
Balingerstr. 26
72406 Bisingen

## Kontakt

**E-Mail:** yasemink1213@gmail.com
**E-Mail:** kontakt@parfumyoursoul.de

## Umsatzsteuer-ID

Wird nicht ausgewiesen, da der Verkäufer Kleinunternehmer im Sinne des UStG ist.

## Haftung für Inhalte

Als Dienstleister bin ich gem. § 7 Abs. 1 TMG für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Jedoch nicht dazu verpflichtet gem. §§ 8-10 TMG als Dienstleister, übermittelte oder gespeicherte Informationen zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen.

Verpflichtungen zur Entfernung oder Sperrung der Nutzung von Informationen nach den allgemeinen Gesetzen bleiben hiervon unberührt. Eine diesbezügliche Haftung ist jedoch erst ab dem Zeitpunkt der Kenntnis einer konkreten Rechtsverletzung möglich. Bei Bekanntwerden von entsprechenden Rechtsverletzungen werden wir diese Inhalte umgehend entfernen.

## Urheberrecht

Die durch die Seitenbetreiberin erstellten Inhalte und Werke auf diesen Seiten unterliegen dem Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechts bedürfen der schriftlichen Zustimmung des jeweiligen Autors.

Kopien und Downloads sind nicht für den kommerziellen Gebrauch gestattet. Die Urheberrechte Dritter werden beachtet, soweit die Inhalte auf dieser Website nicht vom Betreiber erstellt wurden. Sollten Sie dennoch auf eine Verletzung des Urheberrechts aufmerksam werden, so bitte ich um einen Hinweis diesbezüglich. Eine Rechtsverletzung diesbezüglich wird bei Bekanntwerden umgehend entfernt.`;
  };

  if (loading) {
    return (
      <div className="min-h-screen py-12" style={{ backgroundColor: '#E8E0D5' }}>
        <div className="max-w-4xl mx-auto px-4">
          <p className="text-center">Lädt...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen py-12" style={{ backgroundColor: '#E8E0D5' }}>
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="bg-white rounded-lg shadow-md p-8">
          <div className="prose prose-gray max-w-none">
            <ReactMarkdown
              components={{
                h1: ({node, ...props}) => <h1 className="text-3xl font-bold mb-6" style={{ color: '#6D5A47' }} {...props} />,
                h2: ({node, ...props}) => <h2 className="text-2xl font-semibold mb-4 mt-6" style={{ color: '#8B7355' }} {...props} />,
                h3: ({node, ...props}) => <h3 className="text-xl font-semibold mb-3 mt-4" style={{ color: '#8B7355' }} {...props} />,
                p: ({node, ...props}) => <p className="mb-3 text-gray-700" {...props} />,
                a: ({node, ...props}) => <a className="text-blue-600 hover:underline" {...props} />,
                ul: ({node, ...props}) => <ul className="list-disc pl-6 mb-3" {...props} />,
                ol: ({node, ...props}) => <ol className="list-decimal pl-6 mb-3" {...props} />,
                strong: ({node, ...props}) => <strong className="font-semibold" {...props} />,
              }}
            >
              {content}
            </ReactMarkdown>
          </div>

          <div className="mt-8 pt-6 border-t">
            <Link 
              to="/" 
              className="inline-flex items-center text-blue-600 hover:underline"
            >
              ← Zurück zur Startseite
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Impressum;
